<template>
  <group-card title="Call Outcomes" icon="phone">
    <div class="table-container">
      <table class="data-table wide">
        <thead>
          <tr>
            <th>Time</th>
            <th>Agent</th>
            <th>Outcome</th>
            <th>Content</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="log in this.call_outcome_logs">
            <td>{{ (log.created_at ? log.created_at : Date()) | datetime }}</td>
            <td>{{ log.agent_name }}</td>
            <td>{{ log.outcome }}</td>
            <td>{{ log.content }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </group-card>
</template>
<script>
import GroupCard from '@/components/Cards/GroupCard';
import filters from "@/components/utils/filters";
import {mapGetters} from 'vuex';
export default {
  components: {
    GroupCard,
  },
  data() {
    return {
    }
  },
  filters: {
    ...filters,
  },
  watch: {
    async application_id() {
      this.getCallOutcomesLog();
    }
  },
  methods: {
    async getCallOutcomesLog() {
      if (this.application_id !== null) {
        await this.$store.dispatch("get_call_outcome_logs", this.application_id);
      }
    },
  },
  computed: {
    ...mapGetters([
      "application_id",
      "call_outcome_logs"
    ]),
  },
  created() {
    this.getCallOutcomesLog();
  },
};
</script>
<style scoped lang="scss">
</style>

